/* =========================================================
   AVA Custom Theme JavaScript
   Shared utilities and scroll-reveal animations
   ========================================================= */

(function() {
  'use strict';

  // ── Scroll Reveal Observer ──────────────────────────────
  // Elements with class "reveal" fade in when scrolled into view
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      reveals.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      // Fallback: show all immediately
      reveals.forEach(function(el) {
        el.classList.add('visible');
      });
    }
  }

  // ── Init on DOM ready ──────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // ── Re-init on Shopify section events (theme editor) ──
  document.addEventListener('shopify:section:load', function() {
    initScrollReveal();
  });

})();
